import axios from 'axios';
import { QueryClient, QueryCache } from '@tanstack/react-query';
import { getBackendConfig } from '@app/common';
import SentryLogger from '@app/sentry';

export const createNewQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        retry: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        SentryLogger.error('Error when executing query', query.queryKey, error);
      },
    }),
  });

export const queryClient = createNewQueryClient();

export const api = axios.create(getBackendConfig());
